const baseUrl = "./case";

export const getCaseList = () => baseUrl + "/fetchcases";
export const getCaseDetails = () => baseUrl + "/fetchcasedetails";
export const getActivity = () => baseUrl + "/activity";
export const closeCase = () => baseUrl + "/closecase";
export const getClosedCaseList = () => baseUrl + "/fetchclosedcases";
export const getCaseStatus = () => baseUrl + "/casestatus";
export const getCaseType = () => baseUrl + "/casereason";
export const getCaseSpecificType = () => baseUrl + "/casespecificreason";
export const createNewCase = () => baseUrl + "/createnewcase";
export const postNewAttachment = baseUrl + "/createnewcase/addattachment";
export const getAttachment = baseUrl + "/viewcaseattachment";
export const createComment = () => baseUrl + "/createcomment";
